module.exports = __webpack_public_path__ + "img/快速回升-lv4.e789a987.png";